var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJungSplashPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jung_splash_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127,217l25.5,24,6-7.5s6-37.5-27-76.5c7.5,21,12,42,12,51-6-13.5-21-25.5-27-27C127,193,127,217,127,217Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.5,188.5s7.5-21,21-31.5C172,169,165,187.5,162,210A90.81,90.81,0,0,0,155.5,188.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163,230l13-14s4-23.5,14.5-34C178.5,188,163,206,163,230Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJungSplashPlaceholder);
export default __webpack_public_path__ + "static/media/jung_splash_placeholder.63f7ae18becd5db6cb57ac28c29ffaec.svg";
export { ForwardRef as ReactComponent };